import { createSlice } from "@reduxjs/toolkit";

export const uiInit = {
    showAvatar: false,
    showFilter: false,
    backToHome: false
}

export const uiSlice = createSlice({
    name: "uiSlice",
    initialState: uiInit,
    reducers: {
        setUI: (state, action) => {

            state.showAvatar = action.payload.showAvatar
            state.showFilter = action.payload.showFilter
            if (action.payload.backToHome) { state.backToHome = action.payload.backToHome }
        }
    }
}) 

export const { setUI } = uiSlice.actions;

export default uiSlice.reducer;
